import _export from '../internals/export.js';
import numberIsFinite$1 from '../internals/number-is-finite.js';

var $ = _export;
var numberIsFinite = numberIsFinite$1; // `Number.isFinite` method
// https://tc39.es/ecma262/#sec-number.isfinite

$({
  target: 'Number',
  stat: true
}, {
  isFinite: numberIsFinite
});
